import { LeftOutlined } from "@ant-design/icons";
import React from "react";
import "./index.css";

function BackTextComponent({ backText, clickFunctionality }) {
  return (
    <div className="back-text">
      <span
        className="back-text-span"
        onClick={clickFunctionality}
      >
        <LeftOutlined/>
        {backText}
      </span>
    </div>
  );
}

export default BackTextComponent;
